<div class="app-shell">
  <mat-toolbar color="primary" class="toolbar">
    <div class="brand" routerLink="/discussions">
      <img src="/icons/fruitage-icon.svg" alt="Fruitage icon" />
      <span>Fruitage</span>
    </div>

    <div class="family-title" *ngIf="selectedFamily() as fam">
      <mat-icon>diversity_3</mat-icon>
      <span class="family-title__name">{{ fam.name }}</span>
    </div>

    <nav class="nav">
      @for (link of navLinks(); track link.path) {
      <a mat-button [routerLink]="link.path" routerLinkActive="active">
        <mat-icon>{{ link.icon }}</mat-icon>
        {{ link.label }}
      </a>
      }
    </nav>

    <button mat-icon-button class="mobile-menu" [matMenuTriggerFor]="mobileNavMenu" aria-label="Open navigation">
      <mat-icon>menu</mat-icon>
    </button>

    <mat-menu #mobileNavMenu="matMenu">
      @for (link of navLinks(); track link.path) {
      <button mat-menu-item [routerLink]="link.path" routerLinkActive="active">
        <mat-icon>{{ link.icon }}</mat-icon>
        <span>{{ link.label }}</span>
      </button>
      }
      <mat-divider></mat-divider>
      @if (isSignedIn()) {
      <button mat-menu-item class="menu-user" disabled>
        <mat-icon>person</mat-icon>
        <span class="menu-user__name">{{ displayName }}</span>
      </button>
      <button mat-menu-item (click)="openSettings('families')">
        <mat-icon>settings</mat-icon>
        <span>Open settings</span>
      </button>
      <button mat-menu-item (click)="signOut()">
        <mat-icon>logout</mat-icon>
        <span>Sign out</span>
      </button>
      } @else {
      <button mat-menu-item (click)="signIn()">
        <mat-icon>login</mat-icon>
        <span>Sign in</span>
      </button>
      }
    </mat-menu>
  </mat-toolbar>


  <main class="shell">
    @if (isInitializing()) {
    <div class="initializing-spinner">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p>Loading your family workspace...</p>
    </div>
    } @else if (selectedFamily()) {
    <router-outlet></router-outlet>
    } @else if (isSignedIn()) {
    <section class="no-family">
      <h2>Select a family workspace</h2>
      <p>Everything in Fruitage attaches to a family. Pick one to load discussions, feelings, goals, and tasks.</p>
      <button mat-flat-button color="primary" (click)="openFamilyAccessDialog()">Choose family</button>
    </section>
    } @else {
    <router-outlet></router-outlet>
    }
  </main>

  <footer>
    <div>
      <span>Roles:</span>
      @for (role of userRoles; track role) {
      <mat-chip>{{ role }}</mat-chip>
      }
    </div>
    <div class="build" *ngIf="buildInfo() as info">
      <span>API {{ info.gitHash }}</span>
      <span>{{ info.environment }}</span>
    </div>
  </footer>

  <section class="auth-overlay" *ngIf="!isSignedIn()">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Welcome to Fruitage</mat-card-title>
        <mat-card-subtitle>Sign in to join the family workspace</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p>Use your Google account to sync family discussions, feelings, goals, and tasks securely.</p>
      </mat-card-content>
      <mat-card-actions>
        <button mat-raised-button color="primary" (click)="signIn()">Sign in with Google</button>
      </mat-card-actions>
    </mat-card>
  </section>
</div>